import { defineStore } from 'pinia';
import api from '@/services/api';

export const useCallerAudioStore = defineStore('callerAudioSettings', {
  state: () => ({
    agc: false,
    denoise: false,
    isLoaded: false
  }),

  actions: {
    async toggle(v) {
      this[v] = !this[v];
      this.syncWithBackend();
    },

    async fetchSettings() {
      if (this.isLoaded) return; // Don't re-fetch if we already have it
      try {
        const { data } = await api.get('/api/caller/audio-settings');
        this.agc = data.agc;
        this.denoise = data.denoise;
      } finally {
        this.isLoaded = true;
      }
    },

    async syncWithBackend() {
      try {
        await api.post('/api/caller/audio-settings', {
          agc: this.agc,
          denoise: this.denoise
        });
      } finally {
      }
    }
  }
});
